import React from 'react';

const ServiceList = ({ services, currentService, onEdit, onToggleVisibility }) => {
    if (!services.length) {
        return (
            <div className="bg-white p-6 rounded shadow text-center text-gray-500">
                Aucun service trouvé.
            </div>
        );
    }

    return (
        <div className="bg-white p-4 rounded shadow space-y-2">
            {services.map((service) => (
                <div
                    key={service._id}
                    className={`flex justify-between items-center border-b py-3 px-2 rounded hover:bg-gray-50 transition ${currentService?._id === service._id ? 'bg-blue-50' : ''
                        }`}
                >
                    <div className="flex-1 cursor-pointer" onClick={() => onEdit(service)}>
                        <div className="font-semibold text-gray-800">{service.title.fr}</div>
                        <div className="text-sm text-gray-500">{service.price} €</div>
                    </div>
                    <button
                        className={`text-2xl transition ${service.enable ? 'text-green-500 hover:text-green-600' : 'text-gray-400 hover:text-gray-500'
                            }`}
                        onClick={() =>
                            onToggleVisibility({ ...service, enable: !service.enable })
                        }
                    >
                        {service.enable ? '👁️' : '🚫'}
                    </button>
                </div>
            ))}
        </div>
    );
};

export default ServiceList;